import React from 'react';

/**
 * Standard page header: icon avatar + stacked title/subtitle + optional
 * right-aligned actions (buttons). Used across list/management pages.
 * Edit this file to restyle every page's header at once — mirrors the
 * PAGE_CONTENT_WIDTH pattern in utils/uiHelpers.js.
 */
const PageHeader = ({
  icon: Icon,
  iconClassName = 'bg-primary/10 text-primary',
  title,
  subtitle,
  actions,
}) => (
  <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6'>
    <div className='flex items-center gap-4'>
      {Icon && (
        <div
          className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${iconClassName}`}
        >
          <Icon size={24} />
        </div>
      )}
      <div>
        <h1 className='text-2xl font-semibold text-foreground mb-1'>{title}</h1>
        {subtitle && <p className='text-sm text-muted-foreground'>{subtitle}</p>}
      </div>
    </div>
    {actions && <div className='flex items-center gap-3 flex-wrap'>{actions}</div>}
  </div>
);

export default PageHeader;
